import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentData } from '@angular/fire/compat/firestore';

import { ActivityType, ProgramGroup, ProgramGroupData } from './data/program-group.data';
import { ActivityData } from './data/activity.data';
import { getProgramValues } from '@shared/scoring';
import { IActivityData } from '@shared/scoring/types';

@Injectable({
  providedIn: 'root'
})
export class ProgramGroupService {

  activityDict: {[key: string]: ActivityType} = {};
  constructor(private firestore: AngularFirestore) {
    ProgramGroupData.activityTypes.forEach(activity => {
      this.activityDict[activity.id] = {...activity};
    });
   }

  programGroups: ProgramGroup[] = ProgramGroupData.programGroups;

  getActivityTypes(): ActivityType[] {
    return ProgramGroupData.activityTypes;
  }

  getProgramGroups(): ProgramGroup[] {
    return this.programGroups;
  }

  getProgramGroupById(id: string): ProgramGroup {
    return this.programGroups.find(p => p.id == id);
  }

  getActivityNameById(activityTypeId: string): string {
    return this.activityDict[activityTypeId].name;
  }

  getMembershipGrowthPercentagePoints(councilGradingStatDoc: DocumentData) {
    if (!councilGradingStatDoc) {
      return 0;
    }
    
    let growthPercentage = coerceNumberProperty(councilGradingStatDoc.get('membership-growth-percentage-total-points'));
  
    if (growthPercentage >= 200) { 
      // Double start gets extra 25 points
      growthPercentage = 125; 
    } else if (growthPercentage > 100) {
      growthPercentage = 100;
    }

    return growthPercentage
  }
  
  getProgramGroupTotal(programGroup: string, councilGradingStatDoc: DocumentData) {
    if (!councilGradingStatDoc) {
      return 0;
    }

    // Use the shared getProgramValues for all groups
    const activityData: IActivityData = ActivityData.data;
    const docWrapper = {
      get: (key: string) => {
        const val = councilGradingStatDoc?.get?.(key) ?? councilGradingStatDoc?.[key];
        return typeof val === 'number' ? val : Number(val) || 0;
      }
    };
    const values = getProgramValues(programGroup, docWrapper, activityData);

    return values[`${programGroup}-total-points`];
  }

  // createProgramGroups() {
  //   return new Promise<any>((resolve, reject) => {
  //     const batch = this.firestore.firestore.batch();

  //     const programGroupsCol = this.firestore.firestore.collection('programGroups');
  //     this.programGroups.forEach((val) => {
  //       const programGroupDoc = programGroupsCol.doc();
  //       batch.set(programGroupDoc, val);
  //     });

  //     batch.commit().then(res => {}, err => reject(err));
  //   });
  // }
}
